import React from "react";
import useWindowDimensions from "../../../get-diemensions/UseWindowDiemensions";
import { colors } from "../../../themes/Colors";
import { BulletMarker, MedicalCard } from "../../../components";
import { BaseButton } from "../../../components/atoms";

const Welcome = ({ onSignUpClick }) => {
  const { width, height } = useWindowDimensions();
  return (
    <div
      style={{
        width: width,
        maxWidth: 1440,
        backgroundColor: colors.white,
        paddingTop: width > 599 ? 80 : 20,
        paddingBottom: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {/* base welcome */}
      <div
        style={{
          width: "90%",
          minHeight: width > 599 ? 550 : 850,
          height: width > 599 ? 550 : 850,
          display: "flex",
        }}
      >
        <div
          style={{
            flex: width > 599 ? 0.5 : 1,

            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: width > 599 ? null : "center",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              flexDirection: width > 599 ? "row" : "column",
              justifyContent: width > 599 ? "center" : null,
            }}
          >
            {width > 599 ? null : (
              <img
                alt="helath icon"
                src={require("../../../images/icons/healthBlack.png")}
                height={24}
                style={{ marginLeft: width > 599 ? 50 : null }}
              />
            )}
            <h1 style={{ textAlign: width > 599 ? "left" : "center", flex: 1 }}>
              Welcome to Alter-Pharm
            </h1>
            {/* <div style={{ flex: 1 }} /> */}
            {width > 599 ? (
              <img
                alt="helath icon"
                src={require("../../../images/icons/healthBlack.png")}
                height={24}
                style={{ marginLeft: 50 }}
              />
            ) : null}
          </div>
          <p
            style={{
              width: "75%",
              lineHeight: 1.6,
              fontSize: 14,
              fontWeight: "lighter",
              textAlign: width > 599 ? "left" : "center",
            }}
          >
            Alter-Pharm is an Alternative Pharmacy that provides alternative
             medicinal options. Alter-Pharm operates within the  SAHPRA and SAPC
            Medical environment. Alter-Pharm has rolled  out an integrated
            Pharmacy network offering different options to Conventional medicine
            within the legal framework of the  Department of Health.
          </p>
          <h4>Alter-Pharm is compliant with:</h4>
          <BulletMarker
            width={width}
            icon={require("../../../images/icons/verfiyGreen.png")}
            title={"South African Pharmacy Council – compliant pharmacies"}
            description={
              "Fully authorised under South African healthcare regulations"
            }
          />
          <BulletMarker
            width={width}
            icon={require("../../../images/icons/dropperGreen.png")}
            title={"SAHPRA– compliant  Ingredients"}
            description={
              "Sourced from GACP- and GMP-certified cultivation and processing facilities"
            }
          />
          <BulletMarker
            width={width}
            icon={require("../../../images/icons/microscopeGreen.png")}
            title={"Evidence-based treatment protocols"}
            description={
              "Rooted in scientific research and guided by medical professionals"
            }
          />
          <div style={{ display: "flex", marginTop: 20 }}>
            <BaseButton
              label={"Learn More"}
              marginRight={20}
              width={120}
              href={
                "https://www.google.com/search?q=sahpra&sca_esv=5ea039d3f5929d6f&rlz=1C5CHFA_enZA1125ZA1125&sxsrf=AHTn8zqv39llh0lfhJZ6pfisHQDHgpI0AQ%3A1747477514356&ei=CmQoaPG_FaGWxc8P8dyI2Ak&ved=0ahUKEwjx7PuDpaqNAxUhS_EDHXEuApsQ4dUDCBA&uact=5&oq=sahpra&gs_lp=Egxnd3Mtd2l6LXNlcnAiBnNhaHByYTIKECMYgAQYJxiKBTIKEAAYgAQYQxiKBTIKEAAYgAQYFBiHAjILEAAYgAQYkQIYigUyBRAAGIAEMgoQABiABBhDGIoFMgUQABiABDIFEAAYgAQyBRAAGIAEMgoQABiABBhDGIoFSKcZUMEOWLMXcAF4AZABAJgBrwKgAZ4LqgEFMi00LjG4AQPIAQD4AQGYAgagAsQLwgIKEAAYsAMY1gQYR8ICBBAjGCfCAg0QLhiABBhDGNQCGIoFwgIREC4YgAQYkQIYxwEYigUYrwHCAgoQLhiABBhDGIoFwgINEC4YgAQYsQMYQxiKBcICEBAuGIAEGLEDGEMYgwEYigWYAwCIBgGQBgiSBwcxLjAuMy4yoAfDRbIHBTItMy4yuAe8C8IHAzItNsgHJA&sclient=gws-wiz-serp"
              }
            />
            <BaseButton label={"Sign Up"} width={90} onClick={onSignUpClick} />
          </div>
        </div>
        {width > 599 ? (
          <div
            style={{
              flex: 0.5,
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <img
              alt="welcome image"
              src={require("../../../images/landing/welcomeimage.png")}
              height={"100%"}
            />
          </div>
        ) : null}
      </div>
      {width > 599 ? (
        <div
          style={{
            height: 190,
            //   borderStyle: "solid",
            width: "90%",
            maxWidth: 1440,
            marginTop: 50,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              height: 180,

              display: "flex",
              justifyContent: "space-between",
              // marginTop: 10,
            }}
          >
            <MedicalCard
              title={"Homeopathy"}
              image={require("../../../images/landing/homeopathey.png")}
            />
            <MedicalCard
              title={"Naturopathy"}
              image={require("../../../images/landing/naturpathy.png")}
            />
            <MedicalCard
              title={"Traditional Medicine"}
              image={require("../../../images/landing/tradiotionalmedicaine.png")}
            />
            <MedicalCard
              title={"Medicine"}
              image={require("../../../images/landing/medicine.png")}
            />
            <MedicalCard
              title={"Ayurvedic Medicine"}
              image={require("../../../images/landing/AyurvedicMedicaine.png")}
            />
            <MedicalCard
              title={"Unani Tibb"}
              image={require("../../../images/landing/UnaniTibb.png")}
            />
          </div>
          <div style={{ marginTop: null, fontSize: 12, fontWeight: "bold" }}>
            {" "}
            Learn more about medical options {"->"}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Welcome;
